export default {
  resize: '800x800',
  src:''
}